module.exports = __webpack_public_path__ + "img/itx-file-type-mp4.3a080591.svg";